module.exports = __webpack_public_path__ + "static/media/img-card-nine.2af1eab9.jpg";